// External Dependencies
import React from 'react';
import {
  deepPurple100,
} from 'material-ui/styles/colors';
import RobotIcon from 'mdi-material-ui/Robot';

// Local Dependencies
import EmptyState from '../shared/empty-state';

// Component Definition
const DashboardEmptyState = () => (
  <EmptyState
    icon={RobotIcon}
    iconColor={deepPurple100}
    isCentered
    title="Welcome to the Dashboard"
  />
);

export default DashboardEmptyState;



/** WEBPACK FOOTER **
 ** ./src/dashboard/dashboard-empty-state.js
 **/